/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import { useState, useEffect, useMemo } from "react";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { ListaEdificios } from "../../components";
import { useAuthContext } from "../../context/auth";
import { getEdificios, saveUsuario, getUsers, getIntermediarios, updateUsuario, getClientes } from "../../utils";
import styles from "./stylesUsuarios.module.scss";

export const Usuarios = () => {
  const [, setEdificios] = useState([]);
  const methods = useForm();
  const [usuarios, setUsuarios] = useState([]);
  const [sortColumn, setSortColumn] = useState("nombre");
  const [sortDirection, setSortDirection] = useState("asc");
  const [newUser, setNewUser] = useState({
    nombre: "",
    apellido: "",
    email: "",
    rol: "",
    edificiosOk: "",
    entidad: "",
    cargo: "",
  });
  const [showListaEdificios, setShowListaEdificios] = useState(false);
  const [intermediarios, setIntermediarios] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [clientes, setClientes] = useState([]);
  const [searchNombre, setSearchNombre] = useState("");
  const [searchApellido, setSearchApellido] = useState("");
  const [searchEntidad, setSearchEntidad] = useState("");
  const [searchCargo, setSearchCargo] = useState("");
  const [searchCorreo, setSearchCorreo] = useState("");
  const [selectedRoles, setSelectedRoles] = useState({
    agencia: true,
    cliente: true,
    edificio: true,
  });

  const { pais, rol } = useAuthContext();

  const paisMap = {
    Chile: "CHI",
    Perú: "PER",
    Uruguay: "URU",
    Region: "REG",
  };

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getEdificios({ pais: paisMap[pais] });
        if (data && Array.isArray(data) && data.length > 0) {
          setEdificios(data);
        } else {
          setEdificios([]);
        }
      } catch (error) {
        if (error.message === "No data found") {
          setEdificios([]);
        } else {
          console.error("Error al obtener edificios:", error);
          setEdificios([]);
          toast.error("Error al cargar edificios");
        }
      }

      try {
        const data = await getClientes({ pais });
        setClientes(data || []);
      } catch (error) {
        console.error("Error al obtener clientes:", error);
        setClientes([]);
      }
    };

    fetchData();
  }, [pais]);

  const fetchUsuarios = async () => {
    try {
      const newUsuarios = await getUsers();
      setUsuarios(newUsuarios);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };

  useEffect(() => {
    fetchUsuarios();
    const fetchIntermediarios = async () => {
      try {
        const newIntermediarios = await getIntermediarios({ pais });
        setIntermediarios(newIntermediarios);
      } catch (error) {
        console.error("Error al obtener intermediarios:", error);
      }
    };
    fetchIntermediarios();
  }, [pais]);

  const handleEditClick = (usuario) => {
    setEditingUser({
      ...usuario,
      entidad:
        usuario.rol === "agencia" ? usuario.agencia || "" : usuario.rol === "cliente" ? usuario.cliente_id || "" : "",
      cargo: usuario.cargo || "",
    });
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (editingUser && editingUser.id) {
      const originalUser = usuarios.find((u) => u.id === editingUser.id);
      const isEmailChanged = originalUser && originalUser.email.toLowerCase() !== editingUser.email.toLowerCase();
      const paisCode = paisMap[pais] || ""; // ← Nueva línea
      let emailExists = false;
      if (isEmailChanged) {
        emailExists = usuarios.some(
          (usuario) =>
            usuario.email.toLowerCase() === editingUser.email.toLowerCase() &&
            usuario.id !== editingUser.id &&
            usuario.pais === paisCode // ← Agregado en el some()
        );
      }

      if (emailExists) {
        setEmailError("Este correo ya está registrado");
        toast.error("Este correo ya está registrado");
        return;
      }

      if ((editingUser.rol === "agencia" || editingUser.rol === "cliente") && !editingUser.cargo) {
        toast.error("Debe seleccionar un cargo");
        return;
      }

      try {
        const updatedUser = await updateUsuario({
          id: editingUser.id,
          email: editingUser.email,
          agencia: editingUser.rol === "agencia" ? parseInt(editingUser.entidad, 10) : null,
          cliente_id: editingUser.rol === "cliente" ? parseInt(editingUser.entidad, 10) : null,
          cargo: editingUser.cargo,
        });
        if (!updatedUser) {
          console.error("No se recibió un usuario actualizado");
          toast.error("Error al actualizar usuario");
          return;
        }
        setUsuarios((prevUsers) =>
          prevUsers.map((user) => (user.id === updatedUser.id ? { ...user, ...updatedUser } : user))
        );
        setEditingUser(null);
        setIsEditing(false);
        setEmailError("");
        toast.success("Usuario actualizado correctamente");
        await fetchUsuarios();
      } catch (error) {
        console.error("Error saving user:", error);
        toast.error("Error al guardar usuario");
      }
    }
  };

  const handleEmailChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, email: e.target.value });
    }
  };

  const handleEntidadChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, entidad: e.target.value });
    }
  };

  const handleCargoChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, cargo: e.target.value });
    }
  };

  const handleSort = (column) => {
    setSortColumn(column);
    setSortDirection(sortColumn === column && sortDirection === "asc" ? "desc" : "asc");
  };

  const getEntidadNombre = (usuario) => {
    if (usuario.rol === "cliente") {
      const cliente = clientes.find((c) => c.id === usuario.cliente_id);
      return cliente
        ? cliente.empresa === cliente.producto
          ? cliente.nombre
          : `${cliente.empresa} | ${cliente.producto}`
        : "";
    }
    if (usuario.rol === "agencia") {
      return intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "";
    }
    return "";
  };

  const sortedUsuarios = usuarios
    .filter((usuario) => {
      const paisCode = paisMap[pais] || "";
      const validPais = usuario.pais === paisCode;
      const isHabilitado =
        usuario.habilitado === true || usuario.habilitado === null || usuario.habilitado === undefined;
      const isValid = validPais && usuario.email && isHabilitado;
      if (!isValid) return false;

      // Filtrado por cada campo
      const searchNombreLower = searchNombre.toLowerCase().trim();
      const searchApellidoLower = searchApellido.toLowerCase().trim();
      const searchCargoLower = searchCargo.toLowerCase().trim();
      const searchCorreoLower = searchCorreo.toLowerCase().trim();
      const entidadMatch = !searchEntidad
        ? true
        : usuario.rol === "agencia"
          ? usuario.agencia?.toString() === searchEntidad
          : usuario.rol === "cliente"
            ? usuario.cliente_id?.toString() === searchEntidad
            : false;

      return (
        (!searchNombreLower || usuario.nombre?.toLowerCase().includes(searchNombreLower)) &&
        (!searchApellidoLower || usuario.apellido?.toLowerCase().includes(searchApellidoLower)) &&
        entidadMatch &&
        (!searchCargoLower || usuario.cargo?.toLowerCase().includes(searchCargoLower)) &&
        (!searchCorreoLower || usuario.email?.toLowerCase().includes(searchCorreoLower))
      );
    })
    .sort((a, b) => {
      let valueA = a[sortColumn] || "";
      let valueB = b[sortColumn] || "";
      if (sortColumn === "agencia") {
        valueA = getEntidadNombre(a);
        valueB = getEntidadNombre(b);
      }
      return sortDirection === "asc"
        ? String(valueA).localeCompare(String(valueB), "es")
        : String(valueB).localeCompare(String(valueA), "es");
    });

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const getEntidadOptions = () => {
    if (newUser.rol === "agencia") {
      return intermediarios.map((intermediario) => ({
        value: intermediario.id,
        label: intermediario.nombre,
      }));
    }
    if (newUser.rol === "cliente") {
      return clientes.map((cliente) => ({
        value: cliente.id,
        label: cliente.nombre,
      }));
    }
    return [];
  };

  const cargosAgencia = ["Director de cuenta", "Supervisor de cuenta", "Planificador", "Asistente"];
  const cargosCliente = [
    "Director de marketing",
    "Gerente de marketing",
    "Subgerente de marketing",
    "Brand manager",
    "Jefe de medios",
    "Asistente de marketing",
  ];

  const getCargoOptions = () => {
    if (newUser.rol === "agencia") return cargosAgencia;
    if (newUser.rol === "cliente") return cargosCliente;
    return [];
  };

  const getCargoOptionsForEdit = (rol) => {
    if (rol === "agencia") return cargosAgencia;
    if (rol === "cliente") return cargosCliente;
    return [];
  };

  const getEntidadFilterOptions = () => {
    const agenciaOptions = intermediarios.map((intermediario) => ({
      value: intermediario.id.toString(),
      label: intermediario.nombre,
    }));
    const clienteOptions = clientes.map((cliente) => ({
      value: cliente.id.toString(),
      label: cliente.empresa === cliente.producto ? cliente.nombre : `${cliente.empresa} | ${cliente.producto}`,
    }));
    return [...agenciaOptions, ...clienteOptions];
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === "nombre" || name === "apellido") {
      processedValue = capitalizeFirstLetter(value.trimEnd());
    } else if (name === "email") {
      processedValue = value.toLowerCase();
      setEmailError("");
    }
    setNewUser((prevUser) => ({
      ...prevUser,
      [name]: processedValue,
      ...(name === "rol" && value === "cliente" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "agencia" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "edificio" ? { entidad: "", cargo: "" } : {}),
    }));
    if (name === "rol") {
      setShowListaEdificios(value === "edificio");
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");

    const paisCode = paisMap[pais] || "";
    const emailExists = usuarios.some(
      (usuario) => usuario.email.toLowerCase() === newUser.email.toLowerCase() && usuario.pais === paisCode
    );
    if (emailExists) {
      setEmailError("Este correo ya está registrado");
      toast.error("Este correo ya está registrado");
      return;
    }

    if ((newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.entidad) {
      toast.error(`Debe seleccionar un ${newUser.rol === "agencia" ? "intermediario" : "cliente"}`);
      return;
    }

    if ((newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.cargo) {
      toast.error("Debe seleccionar un cargo");
      return;
    }

    if (newUser.rol === "agencia" && newUser.cargo && !cargosAgencia.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Agencia");
      return;
    }
    if (newUser.rol === "cliente" && newUser.cargo && !cargosCliente.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Cliente");
      return;
    }

    const userWithCountryAndIntermediary = {
      nombre: newUser.nombre,
      apellido: newUser.apellido,
      email: newUser.email,
      rol: newUser.rol,
      pais: paisMap[pais] || "",
      edificiosOk: newUser.rol === "edificio" ? edificiosSeleccionados : null,
      agencia: newUser.rol === "agencia" ? parseInt(newUser.entidad, 10) : null,
      cliente_id: newUser.rol === "cliente" ? parseInt(newUser.entidad, 10) : null,
      cargo: newUser.cargo || null,
    };

    try {
      const data = await saveUsuario(userWithCountryAndIntermediary);
      if (Array.isArray(data)) {
        setUsuarios([...usuarios, ...data]);
      } else if (data) {
        setUsuarios([...usuarios, data]);
      }
      setNewUser({
        nombre: "",
        apellido: "",
        email: "",
        rol: "",
        edificiosOk: "",
        entidad: "",
        cargo: "",
      });
      setEmailError("");
      toast.success("Usuario agregado correctamente");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error al agregar usuario:", error);
      toast.error("Error al agregar usuario");
    }
  };

  const handleExportEmails = () => {
    try {
      // Filtrar SOLO agencia, cliente, edificio
      const usuariosExportar = sortedUsuarios.filter(
        (u) =>
          (selectedRoles.agencia && u.rol === "agencia") ||
          (selectedRoles.cliente && u.rol === "cliente") ||
          (selectedRoles.edificio && u.rol === "edificio")
      );

      const correos = usuariosExportar
        .map((u) => u.email?.trim().toLowerCase())
        .filter((email) => email && email.includes("@") && email.includes("."));

      const correosUnicos = [...new Set(correos)];

      if (correosUnicos.length === 0) {
        toast.error("No hay correos válidos para exportar");
        return;
      }

      const roles = Object.keys(selectedRoles)
        .filter((key) => selectedRoles[key])
        .join("-");
      const filename = `correos-${roles}-${paisMap[pais] || "desconocido"}.txt`;
      const blob = new Blob([correosUnicos.join(", ")], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(`Exportados ${correosUnicos.length} correo(s)`);
    } catch (error) {
      console.error("Error exportando:", error);
      toast.error("Error al exportar");
    }
  };

  return (
    <div className={styles.usuariosTable}>
      <div className={styles.headerContainer}>
        <div className="logo-container">
          <img src={logo} alt={`${pais} Logo`} className="logo" />
        </div>
        <FormProvider {...methods}>
          <form onSubmit={handleAddUser} className={styles.formContainer}>
            <div className="row justify-content-center align-items-center">
              <div className="col-4">
                <input
                  type="text"
                  className="form-control mb-2"
                  id="nombre"
                  name="nombre"
                  placeholder="Nombre"
                  value={newUser.nombre}
                  onChange={(e) => {
                    const trimmedValue = e.target.value.trimEnd();
                    handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                  }}
                  onBlur={(e) => {
                    const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                    handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                  }}
                  required
                />
              </div>
              <div className="col-4">
                <input
                  type="text"
                  className="form-control mb-2"
                  id="apellido"
                  name="apellido"
                  placeholder="Apellido"
                  value={newUser.apellido}
                  onChange={(e) => {
                    const trimmedValue = e.target.value.trimEnd();
                    handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                  }}
                  onBlur={(e) => {
                    const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                    handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                  }}
                  required
                />
              </div>
              <div className="col-4">
                <input
                  type="email"
                  className="form-control mb-2"
                  id="email"
                  name="email"
                  placeholder="Correo"
                  value={newUser.email}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value.trim().endsWith(" ")) {
                      handleInputChange({ target: { name: "email", value: value } });
                    }
                  }}
                  onBlur={(e) => {
                    const trimmedValue = e.target.value.trimEnd();
                    if (trimmedValue !== e.target.value) {
                      handleInputChange({ target: { name: "email", value: trimmedValue } });
                    }
                  }}
                  required
                />
                {emailError && <small className="text-danger">{emailError}</small>}
              </div>
              <div className="col-4">
                <select
                  className="form-control mb-2"
                  id="rol"
                  name="rol"
                  value={newUser.rol}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Seleccionar
                  </option>
                  <option value="agencia">Agencia</option>
                  {rol !== "comercial" && <option value="edificio">Edificio</option>}
                  <option value="cliente">Cliente</option>
                </select>
              </div>
              <div className="col-4">
                <select
                  className="form-control mb-2"
                  id="entidad"
                  name="entidad"
                  value={newUser.entidad}
                  onChange={handleInputChange}
                  disabled={newUser.rol !== "agencia" && newUser.rol !== "cliente"}
                >
                  <option value="">Seleccionar {newUser.rol === "agencia" ? "Intermediario" : "Cliente"}</option>
                  {getEntidadOptions().map((option, index) => (
                    <option key={`${newUser.rol}-${option.value}-${index}`} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-4">
                <select
                  className="form-control mb-2"
                  id="cargo"
                  name="cargo"
                  value={newUser.cargo}
                  onChange={handleInputChange}
                  disabled={newUser.rol !== "agencia" && newUser.rol !== "cliente"}
                >
                  <option value="">Seleccionar Cargo</option>
                  {getCargoOptions().map((cargo, index) => (
                    <option key={`new-cargo-${index}`} value={cargo}>
                      {cargo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row justify-content-center mt-2">
              <div className="col-auto">
                <button type="submit" className="btn btn-primary mb-2">
                  Agregar Usuario
                </button>
              </div>
            </div>
          </form>
          {showListaEdificios && (
            <div className="mb-5">
              <ListaEdificios
                forceSubmit={() => {
                  const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");
                  setNewUser((prevState) => ({
                    ...prevState,
                    edificiosOk: edificiosSeleccionados,
                  }));
                }}
              />
            </div>
          )}
        </FormProvider>
      </div>
      <div className={styles.searchContainer}>
        <div className="row justify-content-center align-items-center">
          {/* Buscar Nombre */}
          <div className={styles.col2}>
            <input
              type="text"
              className={`form-control ${styles.formControl}`}
              placeholder="Buscar Nombre"
              value={searchNombre}
              onChange={(e) => setSearchNombre(e.target.value)}
            />
          </div>

          {/* Buscar Apellido */}
          <div className={styles.col2}>
            <input
              type="text"
              className={`form-control ${styles.formControl}`}
              placeholder="Buscar Apellido"
              value={searchApellido}
              onChange={(e) => setSearchApellido(e.target.value)}
            />
          </div>

          {/* Agencia o Cliente */}
          <div className={styles.col2}>
            <select
              className={`form-control ${styles.formControl}`}
              value={searchEntidad}
              onChange={(e) => setSearchEntidad(e.target.value)}
            >
              <option value="">Agencia o Cliente</option>
              {getEntidadFilterOptions().map((option, index) => (
                <option key={`filter-${option.value}-${index}`} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Buscar Cargo */}
          <div className={styles.col2}>
            <input
              type="text"
              className={`form-control ${styles.formControl}`}
              placeholder="Buscar Cargo"
              value={searchCargo}
              onChange={(e) => setSearchCargo(e.target.value)}
            />
          </div>

          {/* Buscar Correo */}
          <div className={styles.col2}>
            <input
              type="text"
              className={`form-control ${styles.formControl}`}
              placeholder="Buscar Correo"
              value={searchCorreo}
              onChange={(e) => setSearchCorreo(e.target.value)}
            />
          </div>

          {/* Exportar Correos */}
          <div className={`${styles.col2} text-end`}>
            <div className="dropdown d-inline-block">
              <button
                className={`btn btn-success dropdown-toggle btn-sm ${styles.btnExport}`}
                type="button"
                id="exportDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Exportar Correos
              </button>
              <ul className="dropdown-menu" aria-labelledby="exportDropdown">
                <li>
                  <div className="dropdown-item">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="check-agencia"
                        checked={selectedRoles.agencia}
                        onChange={(e) => setSelectedRoles((prev) => ({ ...prev, agencia: e.target.checked }))}
                      />
                      <label className="form-check-label" htmlFor="check-agencia">
                        Agencia
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="dropdown-item">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="check-cliente"
                        checked={selectedRoles.cliente}
                        onChange={(e) => setSelectedRoles((prev) => ({ ...prev, cliente: e.target.checked }))}
                      />
                      <label className="form-check-label" htmlFor="check-cliente">
                        Cliente
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="dropdown-item">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="check-edificio"
                        checked={selectedRoles.edificio}
                        onChange={(e) => setSelectedRoles((prev) => ({ ...prev, edificio: e.target.checked }))}
                      />
                      <label className="form-check-label" htmlFor="check-edificio">
                        Edificio
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <div className="dropdown-item text-center">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleExportEmails}
                      disabled={!selectedRoles.agencia && !selectedRoles.cliente && !selectedRoles.edificio}
                    >
                      Exportar
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <table className="table table-bordered table-hover align-middle" style={{ tableLayout: "fixed", width: "100%" }}>
        <thead className="table-dark text-center align-middle">
          <tr>
            <th className={styles.colNombre} onClick={() => handleSort("nombre")} style={{ cursor: "pointer" }}>
              Nombre {sortColumn === "nombre" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th className={styles.colApellido} onClick={() => handleSort("apellido")} style={{ cursor: "pointer" }}>
              Apellido {sortColumn === "apellido" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th className={styles.colAgencia} onClick={() => handleSort("agencia")} style={{ cursor: "pointer" }}>
              Agencia o Cliente {sortColumn === "agencia" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th className={styles.colCargo} onClick={() => handleSort("cargo")} style={{ cursor: "pointer" }}>
              Cargo {sortColumn === "cargo" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th className={styles.colCorreo} onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
              Correo {sortColumn === "email" && (sortDirection === "asc" ? "↑" : "↓")}
            </th>
            <th className={styles.colEdit}>Edit</th>
          </tr>
        </thead>
        <tbody>
          {sortedUsuarios.map((usuario) => (
            <tr key={usuario.id}>
              <td className={styles.colNombre}>{usuario.nombre}</td>
              <td className={styles.colApellido}>{usuario.apellido}</td>
              <td className={styles.colAgencia}>
                {isEditing && editingUser && editingUser.id === usuario.id ? (
                  <select
                    value={editingUser.entidad || ""}
                    onChange={handleEntidadChange}
                    className="form-control"
                    style={{
                      width: "80%",
                      fontSize: "14px",
                      textAlign: "start",
                      margin: "0",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                  >
                    <option value="">Seleccionar {editingUser.rol === "agencia" ? "Intermediario" : "Cliente"}</option>
                    {(editingUser.rol === "agencia"
                      ? intermediarios.map((intermediario) => ({
                          value: intermediario.id,
                          label: intermediario.nombre,
                          keyPrefix: "agencia",
                        }))
                      : editingUser.rol === "cliente"
                        ? clientes.map((cliente) => ({
                            value: cliente.id,
                            label: cliente.producto,
                            keyPrefix: "cliente",
                          }))
                        : []
                    ).map((option) => (
                      <option key={`${option.keyPrefix}-${option.value}`} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                    {usuario.rol === "cliente"
                      ? (() => {
                          const cliente = clientes.find((c) => c.id === usuario.cliente_id);
                          return cliente
                            ? cliente.empresa === cliente.producto
                              ? cliente.nombre
                              : `${cliente.empresa} | ${cliente.producto}`
                            : "-";
                        })()
                      : usuario.rol === "agencia"
                        ? intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "-"
                        : "-"}
                  </span>
                )}
              </td>
              <td className={styles.colCargo}>
                {isEditing && editingUser && editingUser.id === usuario.id ? (
                  <select
                    value={editingUser.cargo || ""}
                    onChange={handleCargoChange}
                    className="form-control"
                    style={{
                      width: "80%",
                      fontSize: "14px",
                      textAlign: "start",
                      margin: "0",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                  >
                    <option value="">Seleccionar Cargo</option>
                    {getCargoOptionsForEdit(editingUser.rol).map((cargo, index) => (
                      <option key={`cargo-${index}`} value={cargo}>
                        {cargo}
                      </option>
                    ))}
                  </select>
                ) : (
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                    {usuario.cargo || "-"}
                  </span>
                )}
              </td>
              <td className={styles.colCorreo}>
                {isEditing && editingUser && editingUser.id === usuario.id ? (
                  <div>
                    <input
                      type="email"
                      value={editingUser.email}
                      onChange={handleEmailChange}
                      className="form-control"
                      style={{
                        width: "80%",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: "0",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                    {emailError && <small className="text-danger">{emailError}</small>}
                  </div>
                ) : (
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                    {usuario.email.toLowerCase()}
                  </span>
                )}
              </td>
              <td className={styles.colEdit}>
                {isEditing && editingUser && editingUser.id === usuario.id ? (
                  <FiSave onClick={handleSaveClick} style={{ cursor: "pointer" }} />
                ) : (
                  <FaEdit onClick={() => handleEditClick(usuario)} style={{ cursor: "pointer" }} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
